import React from 'react'

function Container({ border = false, title, children }) {
    return (
        <div className={`bg-white w-full py-5 px-5 xl:px-6 transition-all delay-150 ease-linear space-y-1 rounded-xl ${border ? 'border' : null}`}>
            {/* Head */}
            {title && (
                <div className=" border-b pb-3">
                    <h3 className="text-[17px] font-semibold">{title}</h3>
                </div>
            )}

            <div className="w-full">
                {children}
            </div>

        </div>
    )
}

export default Container